import { create, fromBinary, toBinary, type MessageInitShape } from "@bufbuild/protobuf";
import {
  ClientMessageSchema,
  ServerMessageSchema,
  type ClientMessage,
  type ServerMessage,
} from "../gen/livesoup/v1/realtime_pb";

export const PROTOCOL_VERSION = 2;

export function encodeClient(msg: ClientMessage): Uint8Array {
  return toBinary(ClientMessageSchema, msg);
}

export function decodeServer(bytes: Uint8Array): ServerMessage {
  return fromBinary(ServerMessageSchema, bytes);
}

/** Helper so call sites read `client({ case: "ping", value: {...} })`; nested values may be partial. */
export function client(msg: MessageInitShape<typeof ClientMessageSchema>["msg"]): ClientMessage {
  return create(ClientMessageSchema, { msg });
}
